const CLEAR = 'snackbar/UPDATE';

/**
 * Snackbar action types.
 * @type {Object}
 */
export default {
  CLEAR
};
